var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"400px"}},[(_vm.loaded)?_c(_vm.component,{tag:"component",attrs:{"updateData":_vm.resData,"isUpdate":true},on:{"submit":_vm.submit}}):_c('a-alert',{attrs:{"message":_vm.$t('k8s.text_265'),"banner":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }